/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { DateRangeType } from '@g17eco/types/common';
import { DataPeriods } from '@utils/dataPeriods';
import { apiClient } from './api';
import { CreateCompanyOnboardingImport, CreateOnboardingData } from '@g17eco/types/onboarding';
import { InitiativeCompany } from '../types/initiativeSurvey';

export interface PortfolioCompaniesFilters {
  dateRange?: DateRangeType;
  period?: DataPeriods | undefined;
  metrics?: string[];
}

export const getPortfolioCompanies = async (portfolioId: string, recursive = true, filters?: PortfolioCompaniesFilters) => {
  return apiClient
    .get(`portfolios/${portfolioId}/companies${recursive ? '/recursive' : ''}`, { params: { ...filters } })
    .then((response) => response.data.data as InitiativeCompany[]);
}

export const createCompanyOnboarding = async (portfolioId: string, data: CreateOnboardingData) => {
  return apiClient
    .post(`/portfolios/${portfolioId}/onboard`, data)
    .then((response) => response.data.data);
}

export const createCompanyOnboardingImport = async (portfolioId: string, data: CreateCompanyOnboardingImport) => {
  return apiClient
    .post(`/portfolios/${portfolioId}/onboard/import`, data)
    .then((response) => response.data.data);
}

export const createPortfolio = (initiativeId: string, name: string) => apiClient
  .post(`initiatives/${initiativeId}/portfolios`, { name })
  .then((response) => response.data.data);

export const getPortfolioById = (portfolioId: string) => apiClient
  .get(`portfolios/${portfolioId}`)
  .then((response) => response.data.data);

export const addHoldingToPortfolio = (portfolioId: string, holdingId: string, weight: number) => apiClient
  .post(`portfolios/${portfolioId}/holdings`, { holdingId: holdingId, weight: weight })
  .then((response) => response.data.data);

export const removeHoldingFromPortfolio = (portfolioId: string, holdingId: string) => apiClient
  .delete(`portfolios/${portfolioId}/holdings/${holdingId}`)
  .then((response) => response.data.data);

export interface HoldingWeightUpdate {
  portfolioId: string;
  holdingId: string;
  weight: number;
}

export const updateHoldingWeightFromPortfolio = ({portfolioId, holdingId, weight}: HoldingWeightUpdate) => apiClient
  .patch(`portfolios/${portfolioId}/holdings/${holdingId}`, { weight })
  .then((response) => response.data.data);
